import styled from 'styled-components';

export const ModalAlvaraLicenca = styled.div`
  text-align: center;
  height: auto;
  display: flex;
  background: #ffffffff;
  border-radius: 12px;
  width: 100%;

  
.button-prox {     
    background: #005a9e;
    color: #fff;
    height: 40px;
    width: 100px;
}
`;

export const ContainerTableAlvaraLicenca = styled.div`
    width: 100%;
    padding: 20px;
    height: auto;
`;

export const ContainerTableAl = styled.div`
  width: 100%;
  margin: 0 auto;


    /* Custom scrollbar X styles */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d4d4d4;
    border-radius: 12px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b0b0b0;
  }
`;

export const BtnExportExcel = styled.div`
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  background-color: #005a9e;
  padding: 10px;
  display: inline-block;
  font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  list-style: none;
  transition: color 100ms;

  &:hover {
    color: #4096ff;
    border: 1px solid #4096ff;
    background: #ffffff;
    transition: 0.2s;
  }

  .icon-btn {
    margin-right: 6px;
  }
`;

export const ItemTable = styled.div`
  width: 100%;
  height: auto;
  border-radius: 8px;
  border-left: 3px solid #e3e3e3;
  background: #fff;
  box-shadow: rgb(0 0 0 / 2%) 0px 3px 3px 0px;

  &:hover {
      background-color: #f6f6f6;
    }

  ul {
    display: flex;
    padding: 8px;

    li {
      margin: 10px;
      list-style-type: none;
      font-size: 12px;
      color: #737373;
      width:100%;
    }
  }

  .icon-logout {
    color: #fff;
    display: flex;
  }
`;

export const ContainerControllers = styled.div`
  display: flex;
  width: 100%;

  .containerRegistr{
      background: white;
    border-radius: 4px;
    position: relative;
    left: 30px;
    border-left: 3px solid #ffe456;
    margin-bottom: 5px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    color: #707070;
  }

  .titleRegistr {
    width: 300px;
    padding: 5px;
  }

  .totalRegistr {
    display: flex;
    width: 100%;
    text-align: left;
    margin: auto;
    padding: 5px 30px;
    border-radius: 8px;

    .iconRegistr {
      width: 50px;
      text-align: center;
      font-size: 22px;
    }

    .numberRegistr {
      font-size: 22px;
      width: auto;
      text-align: center;
      color:#5b5b5b;
    }

    .span {
      padding: 10px 100px;
      border-radius: 8px;
      font-size: 22px;
      color: #605d5d;
      background: #ffffff;
      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
    }
  }
`;

export const ItemInput = styled.div`
width:100%;
`;

export const ItemBtnExport = styled.div`
width:100%;
text-align:right;
`;

export const TitleOS = styled.div`
 width: 90%;
 height: auto;

 ul {
    display: flex;
    padding: 2px;
    margin-left: 73px;

    li {
      margin: 10px;
      list-style-type: none;
      font-size: 14px;
      width:100%;
      text-align:center;
       color: #737373;
    }
  }
`;

export const ContainerBusca = styled.div`
margin: 80px;
    display: inline-flex;
    align-items: center;

.input-id {     
    height: 40px;
    width: 400px;
}


`;